import { Box, Button, Typography, CircularProgress } from "@mui/material";

const FEEDBACK_STATUS_STYLES = {
  OPEN: {
    label: "Needs attention",
    bg: "#FFF7ED",
    color: "#8A5A17",
    dot: "#F4B860",
  },
  RESOLVED: {
    label: "Resolved",
    bg: "#E9F7EF",
    color: "#0C7A45",
    dot: "#4CB679",
  },
};

const FeedbackStatusBar = ({ status, isAdmin, onResolve, isUpdating }) => {
  const style = FEEDBACK_STATUS_STYLES[status] || FEEDBACK_STATUS_STYLES.OPEN;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1.25,
        backgroundColor: style.bg,
        borderRadius: 3,
        mt: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            backgroundColor: style.dot,
          }}
        />
        <Typography
          sx={{ fontSize: 12.5, fontWeight: 700, color: style.color }}
        >
          {style.label}
        </Typography>
      </Box>

      {isAdmin && (
        <Button
          size="small"
          onClick={() => onResolve(status === "RESOLVED" ? "OPEN" : "RESOLVED")}
          disabled={isUpdating}
          sx={{
            fontSize: 11.5,
            fontWeight: 700,
            textTransform: "none",
            borderRadius: "20px",
            px: 1.5,
            minWidth: 0,
            color: status === "RESOLVED" ? "#B3261E" : "#0C7A45",
            "&:hover": {
              backgroundColor:
                status === "RESOLVED"
                  ? "rgba(179,38,30,0.08)"
                  : "rgba(12,122,69,0.08)",
            },
          }}
        >
          {isUpdating ? (
            <CircularProgress size={13} sx={{ color: "inherit" }} />
          ) : status === "RESOLVED" ? (
            "Reopen"
          ) : (
            "Mark resolved"
          )}
        </Button>
      )}
    </Box>
  );
};

export default FeedbackStatusBar;
